(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["horizontal-tabs"] && !Shopify.designMode) return;
  try {
    
  class TabsSwitcher extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('input[type="radio"]');

      this.contents = this.querySelectorAll('.tab-content');
      this.switchTab = this.switchTab.bind(this);
    }

    connectedCallback() {
      this.tabs.forEach((tab) => tab.addEventListener('change', this.switchTab));
    }

    switchTab() {
      const selectedTab = this.querySelector('input[type="radio"]:checked');
      const targetContent = selectedTab ? selectedTab.id : null;

      this.contents.forEach((content) => {
        if (content.getAttribute('data-tab') === targetContent) {
          content.style.display = 'block';
        } else {
          content.style.display = 'none';
        }
      });

      const tabsHeader = this.querySelector('.tab-content-container');

      if (tabsHeader) {
        setTimeout(() => {
          // Scrolling to the top of the tabs header after a small delay
          window.scrollTo({
            top: tabsHeader.getBoundingClientRect().top + window.scrollY - 160, // Adjust 100 for header offset
            behavior: 'smooth',
          });
        }, 100); // Adding a small delay before scrolling
      }
    }
  }

  customElements.define('tabs-switcher', TabsSwitcher);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var hcAddToButton = document.querySelector('.hcaddto  button');
    hcAddToButton.addEventListener('click', function () {
      var addToCartButton = document.querySelector('button[data-add-to-cart]');
      addToCartButton.click();
    });

    var hcOptionsSelects = document.querySelectorAll('.hcoptions select');
    hcOptionsSelects.forEach(function (select) {
      select.addEventListener('change', function () {
        var newValue = select.value;
        var newHandle = select.getAttribute('data-newhandle');
        var variantLabel = document.querySelector(
          '.product-block .variant-input-wrap[data-handle="' +
            newHandle +
            '"] .variant-input[data-value="' +
            newValue +
            '"] label'
        );
        variantLabel.click();
        var prices = document.querySelector('span[data-product-price]').textContent;
        document.querySelector('.hcprices').textContent = prices;
      });
    });

    var variantLabels = document.querySelectorAll('.product-block .variant-input label');
    variantLabels.forEach(function (label) {
      label.addEventListener('click', function (e) {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        var count = 0;
        window.onscroll = function () {
          if (count > 1) {
            return;
          } else {
            window.scrollTo(scrollLeft, scrollTop);
            count += 1;
          }
        };
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-lazy')) {
    class VideoLazy extends HTMLElement {
      connectedCallback() {
        this.template = this.querySelector('template');
        this.overlay = this.querySelector('.video-overlay');
        this.playButton = this.querySelector('.play-button');
        this.videoContainer = null;
        this.isYouTubeVideo = false;
        this.isVideoReady = false;
        this.isLoading = false;
        this.pendingPlay = false;
        this.youtubeInitTimeout = null;

        if (this.playButton) {
          this.setupEventListeners();
        }
      }

      setupEventListeners() {
        this.playButton.addEventListener('click', () => {
          if (this.isLoading) return;
          this.handlePlay();
        });
      }

      setLoading(loading) {
        this.isLoading = loading;
        this.playButton.classList.toggle('loading', loading);
        this.playButton.disabled = loading;
      }

      handlePlay() {
        if (!this.videoContainer) {
          this.setLoading(true);
          this.pendingPlay = true;

          // Charger le contenu du template
          const content = this.template.content.cloneNode(true);
          this.videoContainer = content.querySelector('video, .youtube-player');
          this.isYouTubeVideo = this.videoContainer.classList.contains('youtube-player');

          // Ajouter le conteneur vidéo au DOM
          this.appendChild(this.videoContainer);

          if (this.isYouTubeVideo) {
            this.setupYouTubeVideo();
          } else {
            this.setupHTML5Video();
          }
        } else if (this.isVideoReady) {
          // La vidéo est déjà chargée et prête, on la lance directement
          this.playVideo();
        } else {
          // La vidéo est en cours de chargement, on met en file d'attente
          this.pendingPlay = true;
        }
      }

      setupYouTubeVideo() {
        // Charger l'API YouTube si elle n'est pas déjà chargée
        if (!window.YT) {
          const tag = document.createElement('script');
          tag.src = 'https://www.youtube.com/iframe_api';
          const firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          // Définir la fonction de callback globale
          window.onYouTubeIframeAPIReady = () => {
            this.initYouTubePlayer();
          };
        } else {
          this.initYouTubePlayer();
        }

        // Timeout de sécurité pour l'initialisation
        this.youtubeInitTimeout = setTimeout(() => {
          if (!this.isVideoReady) {
            console.error('YouTube player initialization timeout');
            this.setLoading(false);
            this.pendingPlay = false;
          }
        }, 10000);
      }

      initYouTubePlayer() {
        try {
          const videoId = this.videoContainer.id.split('player-')[1];

          this.player = new YT.Player(this.videoContainer.id, {
            videoId: videoId,
            playerVars: {
              autoplay: 0,
              controls: 1,
              rel: 0,
              showinfo: 0,
              modestbranding: 1,
              playsinline: 1,
              enablejsapi: 1,
            },
            events: {
              onReady: () => {
                clearTimeout(this.youtubeInitTimeout);
                this.isVideoReady = true;
                this.setLoading(false);
                if (this.pendingPlay) {
                  this.pendingPlay = false;
                  this.playVideo();
                }
              },
              onStateChange: (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.overlay.classList.add('hidden');
                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                  this.overlay.classList.remove('hidden');
                }
              },
              onError: (error) => {
                console.error('YouTube player error:', error);
                this.setLoading(false);
                this.pendingPlay = false;
              },
            },
          });
        } catch (error) {
          console.error('Error initializing YouTube player:', error);
          this.setLoading(false);
          this.pendingPlay = false;
        }
      }

      setupHTML5Video() {
        const video = this.videoContainer;

        video.addEventListener('loadeddata', () => {
          this.isVideoReady = true;
          this.setLoading(false);
          if (this.pendingPlay) {
            this.pendingPlay = false;
            this.playVideo();
          }
        });

        video.addEventListener('play', () => {
          this.overlay.classList.add('hidden');
        });

        video.addEventListener('pause', () => {
          this.overlay.classList.remove('hidden');
        });

        video.addEventListener('ended', () => {
          this.overlay.classList.remove('hidden');
        });

        // Forcer le chargement de la vidéo
        video.load();
      }

      playVideo() {
        if (!this.isVideoReady) {
          this.pendingPlay = true;
          return;
        }

        if (this.isYouTubeVideo && this.player && typeof this.player.playVideo === 'function') {
          try {
            this.player.playVideo();
            this.overlay.classList.add('hidden');
          } catch (error) {
            console.error('Error playing YouTube video:', error);
            this.setLoading(false);
          }
        } else if (!this.isYouTubeVideo) {
          try {
            const playPromise = this.videoContainer.play();
            if (playPromise !== undefined) {
              playPromise.catch((error) => {
                console.error('Error playing video:', error);
                this.setLoading(false);
              });
            }
          } catch (error) {
            console.error('Error playing video:', error);
            this.setLoading(false);
          }
        }
      }

      disconnectedCallback() {
        clearTimeout(this.youtubeInitTimeout);

        if (this.player && typeof this.player.destroy === 'function') {
          this.player.destroy();
        }

        this.playButton.removeEventListener('click', this.handlePlay);

        if (!this.isYouTubeVideo && this.videoContainer) {
          this.videoContainer.removeEventListener('loadeddata', null);
          this.videoContainer.removeEventListener('play', null);
          this.videoContainer.removeEventListener('pause', null);
          this.videoContainer.removeEventListener('ended', null);
        }
      }
    }
    // Define the custom element
    customElements.define('video-lazy', VideoLazy);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preparation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-lazy')) {
    class VideoLazy extends HTMLElement {
      connectedCallback() {
        this.template = this.querySelector('template');
        this.overlay = this.querySelector('.video-overlay');
        this.playButton = this.querySelector('.play-button');
        this.videoContainer = null;
        this.isYouTubeVideo = false;
        this.isVideoReady = false;
        this.isLoading = false;
        this.pendingPlay = false;
        this.youtubeInitTimeout = null;

        if (this.playButton) {
          this.setupEventListeners();
        }
      }

      setupEventListeners() {
        this.playButton.addEventListener('click', () => {
          if (this.isLoading) return;
          this.handlePlay();
        });
      }

      setLoading(loading) {
        this.isLoading = loading;
        this.playButton.classList.toggle('loading', loading);
        this.playButton.disabled = loading;
      }

      handlePlay() {
        if (!this.videoContainer) {
          this.setLoading(true);
          this.pendingPlay = true;

          // Charger le contenu du template
          const content = this.template.content.cloneNode(true);
          this.videoContainer = content.querySelector('video, .youtube-player');
          this.isYouTubeVideo = this.videoContainer.classList.contains('youtube-player');

          // Ajouter le conteneur vidéo au DOM
          this.appendChild(this.videoContainer);

          if (this.isYouTubeVideo) {
            this.setupYouTubeVideo();
          } else {
            this.setupHTML5Video();
          }
        } else if (this.isVideoReady) {
          // La vidéo est déjà chargée et prête, on la lance directement
          this.playVideo();
        } else {
          // La vidéo est en cours de chargement, on met en file d'attente
          this.pendingPlay = true;
        }
      }

      setupYouTubeVideo() {
        // Charger l'API YouTube si elle n'est pas déjà chargée
        if (!window.YT) {
          const tag = document.createElement('script');
          tag.src = 'https://www.youtube.com/iframe_api';
          const firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          // Définir la fonction de callback globale
          window.onYouTubeIframeAPIReady = () => {
            this.initYouTubePlayer();
          };
        } else {
          this.initYouTubePlayer();
        }

        // Timeout de sécurité pour l'initialisation
        this.youtubeInitTimeout = setTimeout(() => {
          if (!this.isVideoReady) {
            console.error('YouTube player initialization timeout');
            this.setLoading(false);
            this.pendingPlay = false;
          }
        }, 10000);
      }

      initYouTubePlayer() {
        try {
          const videoId = this.videoContainer.id.split('player-')[1];

          this.player = new YT.Player(this.videoContainer.id, {
            videoId: videoId,
            playerVars: {
              autoplay: 0,
              controls: 1,
              rel: 0,
              showinfo: 0,
              modestbranding: 1,
              playsinline: 1,
              enablejsapi: 1,
            },
            events: {
              onReady: () => {
                clearTimeout(this.youtubeInitTimeout);
                this.isVideoReady = true;
                this.setLoading(false);
                if (this.pendingPlay) {
                  this.pendingPlay = false;
                  this.playVideo();
                }
              },
              onStateChange: (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.overlay.classList.add('hidden');
                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                  this.overlay.classList.remove('hidden');
                }
              },
              onError: (error) => {
                console.error('YouTube player error:', error);
                this.setLoading(false);
                this.pendingPlay = false;
              },
            },
          });
        } catch (error) {
          console.error('Error initializing YouTube player:', error);
          this.setLoading(false);
          this.pendingPlay = false;
        }
      }

      setupHTML5Video() {
        const video = this.videoContainer;

        video.addEventListener('loadeddata', () => {
          this.isVideoReady = true;
          this.setLoading(false);
          if (this.pendingPlay) {
            this.pendingPlay = false;
            this.playVideo();
          }
        });

        video.addEventListener('play', () => {
          this.overlay.classList.add('hidden');
        });

        video.addEventListener('pause', () => {
          this.overlay.classList.remove('hidden');
        });

        video.addEventListener('ended', () => {
          this.overlay.classList.remove('hidden');
        });

        // Forcer le chargement de la vidéo
        video.load();
      }

      playVideo() {
        if (!this.isVideoReady) {
          this.pendingPlay = true;
          return;
        }

        if (this.isYouTubeVideo && this.player && typeof this.player.playVideo === 'function') {
          try {
            this.player.playVideo();
            this.overlay.classList.add('hidden');
          } catch (error) {
            console.error('Error playing YouTube video:', error);
            this.setLoading(false);
          }
        } else if (!this.isYouTubeVideo) {
          try {
            const playPromise = this.videoContainer.play();
            if (playPromise !== undefined) {
              playPromise.catch((error) => {
                console.error('Error playing video:', error);
                this.setLoading(false);
              });
            }
          } catch (error) {
            console.error('Error playing video:', error);
            this.setLoading(false);
          }
        }
      }

      disconnectedCallback() {
        clearTimeout(this.youtubeInitTimeout);

        if (this.player && typeof this.player.destroy === 'function') {
          this.player.destroy();
        }

        this.playButton.removeEventListener('click', this.handlePlay);

        if (!this.isYouTubeVideo && this.videoContainer) {
          this.videoContainer.removeEventListener('loadeddata', null);
          this.videoContainer.removeEventListener('play', null);
          this.videoContainer.removeEventListener('pause', null);
          this.videoContainer.removeEventListener('ended', null);
        }
      }
    }
    // Define the custom element
    customElements.define('video-lazy', VideoLazy);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-and-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-lazy')) {
    class VideoLazy extends HTMLElement {
      connectedCallback() {
        this.template = this.querySelector('template');
        this.overlay = this.querySelector('.video-overlay');
        this.playButton = this.querySelector('.play-button');
        this.videoContainer = null;
        this.isYouTubeVideo = false;
        this.isVideoReady = false;
        this.isLoading = false;
        this.pendingPlay = false;
        this.youtubeInitTimeout = null;

        if (this.playButton) {
          this.setupEventListeners();
        }
      }

      setupEventListeners() {
        this.playButton.addEventListener('click', () => {
          if (this.isLoading) return;
          this.handlePlay();
        });
      }

      setLoading(loading) {
        this.isLoading = loading;
        this.playButton.classList.toggle('loading', loading);
        this.playButton.disabled = loading;
      }

      handlePlay() {
        if (!this.videoContainer) {
          this.setLoading(true);
          this.pendingPlay = true;

          // Charger le contenu du template
          const content = this.template.content.cloneNode(true);
          this.videoContainer = content.querySelector('video, .youtube-player');
          this.isYouTubeVideo = this.videoContainer.classList.contains('youtube-player');

          // Ajouter le conteneur vidéo au DOM
          this.appendChild(this.videoContainer);

          if (this.isYouTubeVideo) {
            this.setupYouTubeVideo();
          } else {
            this.setupHTML5Video();
          }
        } else if (this.isVideoReady) {
          // La vidéo est déjà chargée et prête, on la lance directement
          this.playVideo();
        } else {
          // La vidéo est en cours de chargement, on met en file d'attente
          this.pendingPlay = true;
        }
      }

      setupYouTubeVideo() {
        // Charger l'API YouTube si elle n'est pas déjà chargée
        if (!window.YT) {
          const tag = document.createElement('script');
          tag.src = 'https://www.youtube.com/iframe_api';
          const firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          // Définir la fonction de callback globale
          window.onYouTubeIframeAPIReady = () => {
            this.initYouTubePlayer();
          };
        } else {
          this.initYouTubePlayer();
        }

        // Timeout de sécurité pour l'initialisation
        this.youtubeInitTimeout = setTimeout(() => {
          if (!this.isVideoReady) {
            console.error('YouTube player initialization timeout');
            this.setLoading(false);
            this.pendingPlay = false;
          }
        }, 10000);
      }

      initYouTubePlayer() {
        try {
          const videoId = this.videoContainer.id.split('player-')[1];

          this.player = new YT.Player(this.videoContainer.id, {
            videoId: videoId,
            playerVars: {
              autoplay: 0,
              controls: 1,
              rel: 0,
              showinfo: 0,
              modestbranding: 1,
              playsinline: 1,
              enablejsapi: 1,
            },
            events: {
              onReady: () => {
                clearTimeout(this.youtubeInitTimeout);
                this.isVideoReady = true;
                this.setLoading(false);
                if (this.pendingPlay) {
                  this.pendingPlay = false;
                  this.playVideo();
                }
              },
              onStateChange: (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.overlay.classList.add('hidden');
                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                  this.overlay.classList.remove('hidden');
                }
              },
              onError: (error) => {
                console.error('YouTube player error:', error);
                this.setLoading(false);
                this.pendingPlay = false;
              },
            },
          });
        } catch (error) {
          console.error('Error initializing YouTube player:', error);
          this.setLoading(false);
          this.pendingPlay = false;
        }
      }

      setupHTML5Video() {
        const video = this.videoContainer;

        video.addEventListener('loadeddata', () => {
          this.isVideoReady = true;
          this.setLoading(false);
          if (this.pendingPlay) {
            this.pendingPlay = false;
            this.playVideo();
          }
        });

        video.addEventListener('play', () => {
          this.overlay.classList.add('hidden');
        });

        video.addEventListener('pause', () => {
          this.overlay.classList.remove('hidden');
        });

        video.addEventListener('ended', () => {
          this.overlay.classList.remove('hidden');
        });

        // Forcer le chargement de la vidéo
        video.load();
      }

      playVideo() {
        if (!this.isVideoReady) {
          this.pendingPlay = true;
          return;
        }

        if (this.isYouTubeVideo && this.player && typeof this.player.playVideo === 'function') {
          try {
            this.player.playVideo();
            this.overlay.classList.add('hidden');
          } catch (error) {
            console.error('Error playing YouTube video:', error);
            this.setLoading(false);
          }
        } else if (!this.isYouTubeVideo) {
          try {
            const playPromise = this.videoContainer.play();
            if (playPromise !== undefined) {
              playPromise.catch((error) => {
                console.error('Error playing video:', error);
                this.setLoading(false);
              });
            }
          } catch (error) {
            console.error('Error playing video:', error);
            this.setLoading(false);
          }
        }
      }

      disconnectedCallback() {
        clearTimeout(this.youtubeInitTimeout);

        if (this.player && typeof this.player.destroy === 'function') {
          this.player.destroy();
        }

        this.playButton.removeEventListener('click', this.handlePlay);

        if (!this.isYouTubeVideo && this.videoContainer) {
          this.videoContainer.removeEventListener('loadeddata', null);
          this.videoContainer.removeEventListener('play', null);
          this.videoContainer.removeEventListener('pause', null);
          this.videoContainer.removeEventListener('ended', null);
        }
      }
    }
    // Define the custom element
    customElements.define('video-lazy', VideoLazy);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-lazy')) {
    class VideoLazy extends HTMLElement {
      connectedCallback() {
        this.template = this.querySelector('template');
        this.overlay = this.querySelector('.video-overlay');
        this.playButton = this.querySelector('.play-button');
        this.videoContainer = null;
        this.isYouTubeVideo = false;
        this.isVideoReady = false;
        this.isLoading = false;
        this.pendingPlay = false;
        this.youtubeInitTimeout = null;

        if (this.playButton) {
          this.setupEventListeners();
        }
      }

      setupEventListeners() {
        this.playButton.addEventListener('click', () => {
          if (this.isLoading) return;
          this.handlePlay();
        });
      }

      setLoading(loading) {
        this.isLoading = loading;
        this.playButton.classList.toggle('loading', loading);
        this.playButton.disabled = loading;
      }

      handlePlay() {
        if (!this.videoContainer) {
          this.setLoading(true);
          this.pendingPlay = true;

          // Charger le contenu du template
          const content = this.template.content.cloneNode(true);
          this.videoContainer = content.querySelector('video, .youtube-player');
          this.isYouTubeVideo = this.videoContainer.classList.contains('youtube-player');

          // Ajouter le conteneur vidéo au DOM
          this.appendChild(this.videoContainer);

          if (this.isYouTubeVideo) {
            this.setupYouTubeVideo();
          } else {
            this.setupHTML5Video();
          }
        } else if (this.isVideoReady) {
          // La vidéo est déjà chargée et prête, on la lance directement
          this.playVideo();
        } else {
          // La vidéo est en cours de chargement, on met en file d'attente
          this.pendingPlay = true;
        }
      }

      setupYouTubeVideo() {
        // Charger l'API YouTube si elle n'est pas déjà chargée
        if (!window.YT) {
          const tag = document.createElement('script');
          tag.src = 'https://www.youtube.com/iframe_api';
          const firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          // Définir la fonction de callback globale
          window.onYouTubeIframeAPIReady = () => {
            this.initYouTubePlayer();
          };
        } else {
          this.initYouTubePlayer();
        }

        // Timeout de sécurité pour l'initialisation
        this.youtubeInitTimeout = setTimeout(() => {
          if (!this.isVideoReady) {
            console.error('YouTube player initialization timeout');
            this.setLoading(false);
            this.pendingPlay = false;
          }
        }, 10000);
      }

      initYouTubePlayer() {
        try {
          const videoId = this.videoContainer.id.split('player-')[1];

          this.player = new YT.Player(this.videoContainer.id, {
            videoId: videoId,
            playerVars: {
              autoplay: 0,
              controls: 1,
              rel: 0,
              showinfo: 0,
              modestbranding: 1,
              playsinline: 1,
              enablejsapi: 1,
            },
            events: {
              onReady: () => {
                clearTimeout(this.youtubeInitTimeout);
                this.isVideoReady = true;
                this.setLoading(false);
                if (this.pendingPlay) {
                  this.pendingPlay = false;
                  this.playVideo();
                }
              },
              onStateChange: (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.overlay.classList.add('hidden');
                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                  this.overlay.classList.remove('hidden');
                }
              },
              onError: (error) => {
                console.error('YouTube player error:', error);
                this.setLoading(false);
                this.pendingPlay = false;
              },
            },
          });
        } catch (error) {
          console.error('Error initializing YouTube player:', error);
          this.setLoading(false);
          this.pendingPlay = false;
        }
      }

      setupHTML5Video() {
        const video = this.videoContainer;

        video.addEventListener('loadeddata', () => {
          this.isVideoReady = true;
          this.setLoading(false);
          if (this.pendingPlay) {
            this.pendingPlay = false;
            this.playVideo();
          }
        });

        video.addEventListener('play', () => {
          this.overlay.classList.add('hidden');
        });

        video.addEventListener('pause', () => {
          this.overlay.classList.remove('hidden');
        });

        video.addEventListener('ended', () => {
          this.overlay.classList.remove('hidden');
        });

        // Forcer le chargement de la vidéo
        video.load();
      }

      playVideo() {
        if (!this.isVideoReady) {
          this.pendingPlay = true;
          return;
        }

        if (this.isYouTubeVideo && this.player && typeof this.player.playVideo === 'function') {
          try {
            this.player.playVideo();
            this.overlay.classList.add('hidden');
          } catch (error) {
            console.error('Error playing YouTube video:', error);
            this.setLoading(false);
          }
        } else if (!this.isYouTubeVideo) {
          try {
            const playPromise = this.videoContainer.play();
            if (playPromise !== undefined) {
              playPromise.catch((error) => {
                console.error('Error playing video:', error);
                this.setLoading(false);
              });
            }
          } catch (error) {
            console.error('Error playing video:', error);
            this.setLoading(false);
          }
        }
      }

      disconnectedCallback() {
        clearTimeout(this.youtubeInitTimeout);

        if (this.player && typeof this.player.destroy === 'function') {
          this.player.destroy();
        }

        this.playButton.removeEventListener('click', this.handlePlay);

        if (!this.isYouTubeVideo && this.videoContainer) {
          this.videoContainer.removeEventListener('loadeddata', null);
          this.videoContainer.removeEventListener('play', null);
          this.videoContainer.removeEventListener('pause', null);
          this.videoContainer.removeEventListener('ended', null);
        }
      }
    }
    // Define the custom element
    customElements.define('video-lazy', VideoLazy);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-lazy')) {
    class VideoLazy extends HTMLElement {
      connectedCallback() {
        this.template = this.querySelector('template');
        this.overlay = this.querySelector('.video-overlay');
        this.playButton = this.querySelector('.play-button');
        this.videoContainer = null;
        this.isYouTubeVideo = false;
        this.isVideoReady = false;
        this.isLoading = false;
        this.pendingPlay = false;
        this.youtubeInitTimeout = null;

        if (this.playButton) {
          this.setupEventListeners();
        }
      }

      setupEventListeners() {
        this.playButton.addEventListener('click', () => {
          if (this.isLoading) return;
          this.handlePlay();
        });
      }

      setLoading(loading) {
        this.isLoading = loading;
        this.playButton.classList.toggle('loading', loading);
        this.playButton.disabled = loading;
      }

      handlePlay() {
        if (!this.videoContainer) {
          this.setLoading(true);
          this.pendingPlay = true;

          // Charger le contenu du template
          const content = this.template.content.cloneNode(true);
          this.videoContainer = content.querySelector('video, .youtube-player');
          this.isYouTubeVideo = this.videoContainer.classList.contains('youtube-player');

          // Ajouter le conteneur vidéo au DOM
          this.appendChild(this.videoContainer);

          if (this.isYouTubeVideo) {
            this.setupYouTubeVideo();
          } else {
            this.setupHTML5Video();
          }
        } else if (this.isVideoReady) {
          // La vidéo est déjà chargée et prête, on la lance directement
          this.playVideo();
        } else {
          // La vidéo est en cours de chargement, on met en file d'attente
          this.pendingPlay = true;
        }
      }

      setupYouTubeVideo() {
        // Charger l'API YouTube si elle n'est pas déjà chargée
        if (!window.YT) {
          const tag = document.createElement('script');
          tag.src = 'https://www.youtube.com/iframe_api';
          const firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          // Définir la fonction de callback globale
          window.onYouTubeIframeAPIReady = () => {
            this.initYouTubePlayer();
          };
        } else {
          this.initYouTubePlayer();
        }

        // Timeout de sécurité pour l'initialisation
        this.youtubeInitTimeout = setTimeout(() => {
          if (!this.isVideoReady) {
            console.error('YouTube player initialization timeout');
            this.setLoading(false);
            this.pendingPlay = false;
          }
        }, 10000);
      }

      initYouTubePlayer() {
        try {
          const videoId = this.videoContainer.id.split('player-')[1];

          this.player = new YT.Player(this.videoContainer.id, {
            videoId: videoId,
            playerVars: {
              autoplay: 0,
              controls: 1,
              rel: 0,
              showinfo: 0,
              modestbranding: 1,
              playsinline: 1,
              enablejsapi: 1,
            },
            events: {
              onReady: () => {
                clearTimeout(this.youtubeInitTimeout);
                this.isVideoReady = true;
                this.setLoading(false);
                if (this.pendingPlay) {
                  this.pendingPlay = false;
                  this.playVideo();
                }
              },
              onStateChange: (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.overlay.classList.add('hidden');
                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                  this.overlay.classList.remove('hidden');
                }
              },
              onError: (error) => {
                console.error('YouTube player error:', error);
                this.setLoading(false);
                this.pendingPlay = false;
              },
            },
          });
        } catch (error) {
          console.error('Error initializing YouTube player:', error);
          this.setLoading(false);
          this.pendingPlay = false;
        }
      }

      setupHTML5Video() {
        const video = this.videoContainer;

        video.addEventListener('loadeddata', () => {
          this.isVideoReady = true;
          this.setLoading(false);
          if (this.pendingPlay) {
            this.pendingPlay = false;
            this.playVideo();
          }
        });

        video.addEventListener('play', () => {
          this.overlay.classList.add('hidden');
        });

        video.addEventListener('pause', () => {
          this.overlay.classList.remove('hidden');
        });

        video.addEventListener('ended', () => {
          this.overlay.classList.remove('hidden');
        });

        // Forcer le chargement de la vidéo
        video.load();
      }

      playVideo() {
        if (!this.isVideoReady) {
          this.pendingPlay = true;
          return;
        }

        if (this.isYouTubeVideo && this.player && typeof this.player.playVideo === 'function') {
          try {
            this.player.playVideo();
            this.overlay.classList.add('hidden');
          } catch (error) {
            console.error('Error playing YouTube video:', error);
            this.setLoading(false);
          }
        } else if (!this.isYouTubeVideo) {
          try {
            const playPromise = this.videoContainer.play();
            if (playPromise !== undefined) {
              playPromise.catch((error) => {
                console.error('Error playing video:', error);
                this.setLoading(false);
              });
            }
          } catch (error) {
            console.error('Error playing video:', error);
            this.setLoading(false);
          }
        }
      }

      disconnectedCallback() {
        clearTimeout(this.youtubeInitTimeout);

        if (this.player && typeof this.player.destroy === 'function') {
          this.player.destroy();
        }

        this.playButton.removeEventListener('click', this.handlePlay);

        if (!this.isYouTubeVideo && this.videoContainer) {
          this.videoContainer.removeEventListener('loadeddata', null);
          this.videoContainer.removeEventListener('play', null);
          this.videoContainer.removeEventListener('pause', null);
          this.videoContainer.removeEventListener('ended', null);
        }
      }
    }
    // Define the custom element
    customElements.define('video-lazy', VideoLazy);
  }

  } catch(e) { console.error(e); }
})();
})();
